import _assign from "object-assign";

function createLightPalette(_ref) {
  var blue500 = _ref.blue500,
      grey900 = _ref.grey900;
  return {
    color: grey900,
    state: {
      active: {
        color: blue500
      },
      hover: {
        color: blue500
      }
    }
  };
}

function createDarkPalette(_ref2) {
  var blue200 = _ref2.blue200,
      white = _ref2.white;
  return {
    color: white,
    state: {
      active: {
        color: blue200
      },
      hover: {
        color: blue200
      }
    }
  };
}

function getPalette(palette) {
  if (palette.type === 'dark') {
    return createDarkPalette(palette);
  }

  return createLightPalette(palette);
}

export var style = function style(_ref3) {
  var toolkitTheme = _ref3.toolkit;
  var getDisabled = toolkitTheme.disabled.getDisabled,
      getFocusable = toolkitTheme.focusable.getFocusable,
      palette = toolkitTheme.palette,
      _toolkitTheme$typogra = toolkitTheme.typography,
      getFace = _toolkitTheme$typogra.getFace,
      lineHeight = _toolkitTheme$typogra.lineHeight;

  var _getPalette = getPalette(palette),
      color = _getPalette.color,
      state = _getPalette.state;

  return {
    root: _assign({
      color: color,
      letterSpacing: 0,
      lineHeight: lineHeight
    }, getFace(), {
      textDecoration: 'underline',
      '&:visited': {
        color: 'currentColor',
        '& $icon': {
          color: 'currentColor'
        }
      },
      '&:focus': getFocusable(),
      '&:hover': {
        color: state.hover.color,
        '& $icon': {
          color: state.hover.color
        }
      },
      '&:active': {
        color: state.active.color,
        '& $icon': {
          color: state.active.color
        }
      }
    }),
    disabled: _assign({}, getDisabled(), {
      '&:hover': {
        color: color
      }
    }),
    icon: {
      padding: [[0, 0, 0, 6]]
    }
  };
};